/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import color from '../../../constants/color';
import materialUI from '../../../material-UI';
import {
  MenuItem,
  Input,
} from './styles';

const useStyles = materialUI.makeStyles({
  root: {
    '& fieldset': {
      borderRadius: 40,
    },
  },
  input: {
    color: color.grey9,
  },
});

interface Props {
  open: boolean;
  onClose: any;
  onOpen: any;
  value: any;
  onChange: any;
  data: Array<any>;
  isMultiple: boolean;
  label?: string;
}

const SelectComponent: React.FC<Props> = ({
  data,
  onChange,
  value,
  isMultiple,
  label,
}) => (
  <Input
    fullWidth
    classes={{ root: useStyles().root }}
    select
    value={value}
    variant="outlined"
    label={label}
    inputProps={{ className: useStyles().input }}
    SelectProps={{
      multiple: isMultiple,
      value,
      onChange,
    }}
  >
    {data.map((item) => (
      isMultiple ? <MenuItem value={item}>{item.nome}</MenuItem>
        : <MenuItem value={item.id || item.idPerfilAcesso}>{item.nome}</MenuItem>
    ))}
  </Input>
);
export default SelectComponent;
